import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ContentChildren,
    ElementRef,
    HostListener,
    Input,
    QueryList,
    inject,
} from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

import { TooltipService } from './tooltip.service';

@Component({
    selector: 'ms-inline-tooltip',
    template: '<ng-content />',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineTooltipComponent implements AfterViewInit {
    private elementRef = inject(ElementRef);
    private tooltip = inject(TooltipService);
    private deviceService = inject(DeviceService);

    @Input() showOnlyIfOverflowed = true;
    @Input() applyClass = 'inline-tooltip-msg';
    @Input() tooltipPlacement = 'right';
    @Input() hideOnScroll = true;
    @Input() showOnLoad = false;
    @Input() appendContent = false;

    @ContentChildren('tooltipContent', { descendants: true, read: ElementRef }) tooltipContent: QueryList<ElementRef<HTMLElement>>;

    private elements: HTMLElement[] = [];

    @HostListener('mouseenter')
    onHover(): void {
        this.showTooltip(this.isTooltipVisible());
    }

    @HostListener('mouseleave')
    nohover(): void {
        this.tooltip.hide(this.showOnLoad);
    }

    ngAfterViewInit(): void {
        this.showTooltip(this.showOnLoad);
    }

    private showTooltip(show: boolean): void {
        if (!show) {
            return;
        }

        this.tooltip.show({
            reference: this.elementRef,
            content: this.tooltipContent.toArray(),
            cssClass: this.applyClass,
            tooltipPlacement: this.tooltipPlacement,
            hideOnScroll: this.hideOnScroll,
            showOnLoad: this.showOnLoad,
            appendContent: this.appendContent,
        });
    }

    private isTooltipVisible(): boolean {
        if (this.deviceService.isTouch || this.showOnLoad) {
            return false;
        }
        return !(this.showOnlyIfOverflowed && !this.isOverflowed());
    }

    private isOverflowed(): boolean {
        if (this.elements.length === 0) {
            this.elements = this.tooltipContent.toArray().map((x) => x.nativeElement);
        }

        return this.elements.some((el) => el.offsetWidth < el.scrollWidth || el.offsetHeight + 1 < el.scrollHeight);
    }
}
